export type AffordabilityFormDataType = {
  secondaryApplicantExist: string;
  primaryApplicantIncome: string;
  secondaryApplicantIncome: string;
  maritalStatus: string;
  children: number;
  cars: number;
  propertiesToSell: boolean;
  loansRemainingBalance: string;
  housingCompanyDebt: string;
  otherLoans: boolean;
  personalLoansBalance: string;
  creditCards: boolean;
  creditCardsLimit: string;
};

export const maritalStatuses = {
  cohabitant: 'cohabitant',
  married: 'married',
  single: 'single',
  widow: 'widow',
};

export type AffordabilityRequest = {
  applicant: {
    netMonthlyIncome: number;
  };
  coapplicant?: {
    netMonthlyIncome: number;
  };
  maritalstatus: string;
  numberOfChildren: number;
  numberOfCars: number;
  properties: {
    type: string;
    remainingDebt: number;
    shareOfHousingLoan?: number;
  }[];
  loans: {
    type: string;
    remainingDebt: number;
  }[];
  creditCards: {
    limit: number;
  }[];
};

export type AffordabilityResponse = {
  loanAmount: number;
  interestRate: number;
};

export enum MaritalStatusEnum {
  MARRIED = 'MA',
  SINGLE = 'SI',
}
